import React from 'react';
import Skeleton from '@mui/material/Skeleton';

export function RssSkeleton() {
  return (
    <section
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: '1rem',
        marginTop: '2rem',
        gap: '32px',
        boxSizing: 'border-box',
      }}
      className="qlf-skeleton rss-component"
      data-testid="skeleton"
      role="status"
      aria-live="polite"
      // not translated as this is backend rendered and while we have the locale at hand, it's not handy to make i18next work with SSR
      aria-label="Loading RSS feed"
    >
      {[...Array(5)].map((_, index) => (
        <div
          key={index}
          style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}
        >
          {/* Image */}
          <Skeleton variant="rectangular" height={180} width="100%" animation="wave" />

          {/* Title */}
          <Skeleton variant="text" height={28} width="80%" animation="wave" />

          {/* Description (3 lines) */}
          <div style={{ width: '100%' }}>
            <Skeleton variant="text" height={20} width="100%" animation="wave" />
            <Skeleton variant="text" height={20} width="95%" animation="wave" />
            <Skeleton variant="text" height={20} width="90%" animation="wave" />
          </div>

          {/* Link */}
          <Skeleton variant="text" height={20} width="30%" animation="wave" />
        </div>
      ))}
    </section>
  );
}
